import { ReceptionDetailPermissions } from ".";
import { ReceptionDispInfo } from "..";

// 依頼参照画面表示用model
export class ReceptionReferenceDispInfo {
  constructor() {
    this.labelSetting = new ReceptionDispInfo();
    this.permissions = new ReceptionDetailPermissions();
  }

  public labelSetting: ReceptionDispInfo;
  public permissions: ReceptionDetailPermissions;

}
